import {
	Col,
	Form,
	Input,
	Modal,
	Row,
	Flex,
	Typography,
	Button,
	Image,
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

const { Title, Text } = Typography;

const PlantType = ({ load }) => {
	const [form] = Form.useForm();
	const [openSlumpModal, setOpenSlumpModal] = useState(false);
	const [openTemperatureModal, setOpenTemperatureModal] = useState(false);
	const [initialValues, setInitialValues] = useState({});

	useEffect(() => {
		if (load) {
			setInitialValues({
				plantSlump: load.plantSlump || 0,
				plantSlumpUrl: load.plantSlumpUrl,
				plantTemperature: load.plantTemperature
					? `${load.plantTemperature} °F`
					: "0",
				plantTemperatureUrl: load.plantTemperatureUrl,
				date: load.date
					? dayjs(load.date).format("MM/DD/YYYY hh:mm:ss A")
					: "-",
				toJobDate: load.toJobDate
					? dayjs(load.toJobDate).add(6, "h").format("MM/DD/YYYY hh:mm:ss A")
					: "-",
			});
		}
	}, [load]);

	const handleSlumpModal = () => {
		setOpenSlumpModal((prev) => !prev);
	};

	const RenderSlumpModal = () => {
		return (
			<Modal
				title={`Slump image in load ${load.deliveryTicket}`}
				open={openSlumpModal}
				onCancel={handleSlumpModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Image width={"100%"} src={load.plantSlumpUrl} />
			</Modal>
		);
	};

	const handleTemperatureModal = () => {
		setOpenTemperatureModal((prev) => !prev);
	};

	const RenderTemperatureModal = () => {
		return (
			<Modal
				title={`Temperature image in load ${load.deliveryTicket}`}
				open={openTemperatureModal}
				onCancel={handleTemperatureModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Image width={"100%"} src={load.plantTemperatureUrl} />
			</Modal>
		);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={12} md={8}>
						<Form.Item label="Slump" name="plantSlump">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Slump Image" name="plantSlumpUrl">
							{load.plantSlumpUrl ? (
								<Button type="primary" size="large" onClick={handleSlumpModal}>
									View Image
								</Button>
							) : (
								<Text>No image attached</Text>
							)}
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Temperature" name="plantTemperature">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Temperature Image" name="plantTemperatureUrl">
							{load.plantTemperatureUrl ? (
								<Button
									type="primary"
									size="large"
									onClick={handleTemperatureModal}
								>
									View Image
								</Button>
							) : (
								<Text>No image attached</Text>
							)}
						</Form.Item>
					</Col>

					<Col span={12} md={8}>
						<Form.Item label="Loading Time" name="date">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Departure time for delivery" name="toJobDate">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Flex vertical>
			<Title level={1}>Plant</Title>
			<CustomForm />
			<RenderSlumpModal />
			<RenderTemperatureModal />
		</Flex>
	);
};

export default PlantType;
